<div class="header">
  <div class="header_title">
    {{ title }}
  </div>
  <div class="header_closer" (click)="close()">
    <i class="fal fa-times"></i>
  </div>
</div>
<div class="product-topbar">
  <span class="product_avail"
    >Available On:
    <span *ngFor="let item of availableOn">
      <img [src]="availableChannels[item]?.url" alt=""
    /></span>
  </span>
  <span class="product_avail"
  >Total Stock: <span class="product_avail-stock">{{productDetail?.totalStock}}</span>
 </span>


  <span class="action ms-auto">
    <span class="d-flex align-items-center me-2">Active
      <mat-slide-toggle class="ms-2"  [formControl]="deleteFlag" (change)="onChange($event)"></mat-slide-toggle> </span>

  
    <app-button
      [buttonSize]="'action small'"
      [buttonStyle]="'wire'"
      [buttonColor]="'primary'"
      [buttonStyle]="''"

      (click)= cancel()

      *ngIf="!isEdit"
    >
      Cancel
    </app-button>
     <app-button
      [buttonSize]="'action small'"
      [buttonStyle]="'wire'"
      [buttonColor]="'primary'"
      [buttonStyle]="''"
      [spin]="loading"
      (click)="isEdit ? edit() : saveProduct(true)"
    >
      {{ isEdit ? "Edit" : "Save" }}
    </app-button>
  </span>
</div>
<div class="detail-container" #container>
  <div class="top">
    <div
      class="top_image"
      [style.backgroundImage]="
        'url(' +
        (product && product.imageUrl
          ? product.imageUrl
          : '' || 'assets/images/No_image.png') +
        ')'
      "
    ></div>
    <div class="top_form" [formGroup]="productForm">
      <div class="input-container">
        <label for="" class="input-container_label">Name*</label>
        <input
          type="text"
          class="input-container_input"
          [ngClass]="{
            'input-container_input_edit': !isEdit
          }"
          formControlName="name"
        />
        <div
          class="input-container_error-message"
          *ngIf="productForm.controls['name'].errors?.unique"
        >
          Item name already exists for this vendor
        </div>
      </div>

      <div class="input-container">
        <label for="" class="input-container_label">Description</label>
        <input
          type="text"
          class="input-container_input"
          [ngClass]="{
            'input-container_input_edit': !isEdit
          }"
          formControlName="title"
        />
      </div>

      <div class="input-container">
        <label for="" class="input-container_label">Brand</label>
        <input
          type="text"
          class="input-container_input"
          [ngClass]="{
            'input-container_input_edit': !isEdit
          }"
          formControlName="brand"
        />
      </div>

      <div class="input-container">
        <label for="" class="input-container_label">Model</label>
        <input
          type="text"
          class="input-container_input"
          [ngClass]="{
            'input-container_input_edit': !isEdit
          }"
          formControlName="model"
        />
      </div>

      <div class="input-container">
        <label for="" class="input-container_label">Color</label>
        <input
          type="text"
          class="input-container_input"
          [ngClass]="{
            'input-container_input_edit': !isEdit
          }"
          formControlName="color"
        />
      </div>

      <div class="input-container">
        <label for="" class="input-container_label">UPC</label>
        <input
          type="text"
          class="input-container_input"
          [ngClass]="{
            'input-container_input_edit': !isEdit
          }"
          formControlName="upc"
        />
      </div>

      <div class="input-container">
        <label for="" class="input-container_label">Image URL</label>
        <input
          type="text"
          class="input-container_input img-long-text"
          [ngClass]="{
            'input-container_input_edit': !isEdit
          }"
          formControlName="imageUrl"
          (blur)="updateImage()"
        />
      </div>
      
      <div class="input-container">
        <label for="" class="input-container_label">Note</label>
        <input
          type="text"
          class="input-container_input"
          [ngClass]="{
            'input-container_input_edit': !isEdit
          }"
          formControlName="notes"
        />
      </div>

      <div class="input-container">
        <label for="" class="input-container_label">Default Location</label>
        <input
          type="text"
          class="input-container_input"
          [ngClass]="{
            'input-container_input_edit': !isEdit
          }"
          formControlName="defaultLocation"
        />
      </div>


      <div class="input-container">
        <label for="" class="input-container_label"
          >L <span class="gray"> (inch)</span></label
        >
        <input
          type="number"
          class="input-container_input"
          [ngClass]="{
            'input-container_input_edit': !isEdit
          }"
          formControlName="length"
        />
      </div>

      <div class="input-container">
        <label for="" class="input-container_label"
          >W <span class="gray"> (inch)</span></label
        >
        <input
          type="number"
          class="input-container_input"
          [ngClass]="{
            'input-container_input_edit': !isEdit
          }"
          formControlName="width"
        />
      </div>

      <div class="input-container">
        <label for="" class="input-container_label"
          >H <span class="gray"> (inch)</span></label
        >
        <input
          type="number"
          class="input-container_input"
          [ngClass]="{
            'input-container_input_edit': !isEdit
          }"
          formControlName="height"
        />
      </div>

      <div class="input-container">
        <label for="" class="input-container_label"
          >Weight <span class="gray"> (LB)</span></label
        >
        <input
          type="number"
          class="input-container_input"
          [ngClass]="{
            'input-container_input_edit': !isEdit
          }"
          formControlName="weight"
        />
      </div>
      <div class="indicator-tags">
        <label for="" class="input-container_label mb-0 mr-2">Tags:</label>
         <span *ngFor="let tag of productTagsDto" class="indicator-tags_tags" [matTooltip]="tag.name" [style.backgroundColor]="tag?.colorCode" > 
          {{tag.name}} <span class="tagDelete" (click)="deleteTag(tag.tagId)">
            <i class="fal fa-times-circle"></i>
          </span></span>
        <span class="indicator-tags_addTags" (click)="openAllTag($event)">
          <i class="fal fa-plus hand"></i>
        </span>
      </div>
    </div>
  </div>
  <ng-container *ngIf="productId">
    <div class="detail">
      <div class="detail_tabs">
        <app-horizontal-tabs
          (actionEvent)="tabClicked($event)"
          [tabs]="[
            'Dashboard',
            'Basic info',
            'Stock',
            'Orders',
            'Purchase Orders',
            'History',
            'Shipments',
            'Analytics'
          ]"
          [activeTab]="activeTab"
        ></app-horizontal-tabs>
      </div>
      <div class="detail_content product-ag-table">
        <div class="d-flex flex-column w-100 h-100 grid-gap-19">
          <ng-container *ngIf="activeTab !== 'Dashboard' && activeTab!='Analytics'">
            <div [ngClass]="activeTab === 'Basic info' ? 'flex-grow' : 'flex-grow-1'" >
              <ng-container *ngIf="activeTab === 'Basic info'">
                <h1 class="font-14 font-bold">Vendors</h1>
                <div
                  class="detail_action"
                  [hidden]="activeTab !== 'Basic info'"
                >
                  <app-button [buttonStyle]="'text'" (click)="newVendorItem()"
                    >Add  Vendor Item</app-button
                  >
                </div>
              </ng-container>
              <ng-container *ngIf="activeTab === 'Purchase Orders'">
                <h1 class="font-14 font-bold"></h1>
                <div
                  class="detail_action"
                  [hidden]="activeTab !== 'Purchase Orders'"
                >
                  <app-button [buttonStyle]="'text'" (click)="newPo()"
                    >Add PO</app-button
                  >
                </div>
              </ng-container>
              <h1 class="font-14 font-bold" *ngIf="activeTab === 'Stock'">
                Warehouse Summary
              </h1>
              <div *ngIf="activeTab === 'Stock'"
              class="detail_action"
            >
              <app-button [buttonStyle]="'text'" (click)="addLocation()"
                >Add Stock</app-button
              >
            </div>
            <div class="d-flex align-items-center justify-content-end mb-2" *ngIf="activeTab=='Purchase Orders'" >Deleted PO
              <mat-slide-toggle class="ms-2" [formControl]="IsDeletedPo" (change)="onChangeToggle($event)"></mat-slide-toggle>
             </div>
              <ag-grid-angular
                style="width: 100%; min-height: 150px;"
                [ngStyle]="{
                  height:
                    activeTab === 'Basic info'
                      ? '190px'
                      : 'calc(100% - 29px)',
                }"
                class="ag-theme-alpine-po-detail"
                [gridOptions]="gridOptions"
                [columnDefs]="columnDefs"
                [modules]="modules"
                (gridReady)="gridReady($event)"
                [getRowHeight]="getRowHeight"
                [headerHeight]="41"
                *ngIf="gridOptions"
              >
              </ag-grid-angular>
            </div>
            <div *ngIf="activeTab === 'Basic info'" class="flex-grow-1">
              <h1 class="font-14 font-bold">Listings</h1>
              <div class="detail_action" [hidden]="activeTab !== 'Basic info'">
                <app-button [buttonStyle]="'text'" (click)="newMapping()">Add Mapping</app-button>
              </div>
              <ag-grid-angular
                style="width: 100%; height: calc(100% - 23px); min-height: 150px;"
                class="ag-theme-alpine-po-detail"
                [gridOptions]="listingGridOptions"
                [columnDefs]="listingColumnDefs"
                [modules]="modules"
                (gridReady)="listingGridReady($event)"
                [headerHeight]="41"
                [rowHeight]="58"
              >
              </ag-grid-angular>
            </div>
          </ng-container>
          <ng-container *ngIf="activeTab === 'Dashboard'">
            <app-product-dashboard
              [productId]="productId"
              [width]="container.offsetWidth"
              *ngIf="productId"
            ></app-product-dashboard>
          </ng-container>

          <ng-container *ngIf="activeTab=='Analytics'">
            <div class="row-box row custom-scrollv2">
              <div class="col-md-5">
                <app-kpi-dashboard [label]="'1-30 Days'"  [id]="'leftCard'" [productId]="productId"[page]="'productDetailPanel'"
                *ngIf="productId"></app-kpi-dashboard>
              </div>
              <div class="col-md-5">
                <app-kpi-dashboard [label]="'31-60 Days'" [id]="'middleCard'" [productId]="productId" [page]="'productDetailPanel'"
                *ngIf="productId"></app-kpi-dashboard>
              </div>
              <div class="col-md-5">
                <app-kpi-dashboard [label]="'61-90 Days'" [id]="'rightCard'" [productId]="productId" [page]="'productDetailPanel'"
                *ngIf="productId"></app-kpi-dashboard>
              </div>
            </div>
            <div>
              <app-kpis-sales-graph *ngIf="productId" [productId]="productId"></app-kpis-sales-graph>
            </div>
          </ng-container>

        </div>
      </div>
    </div>
  </ng-container>
</div>
